<template>
  <div>
    <div v-if="loading" >
    <b-skeleton class="skeleton-input"></b-skeleton>
    <b-skeleton class="skeleton-label"></b-skeleton>
    </div>
    <div v-else class="validate-patient">
      <label class="cpf-field-label"><span style="color: #f04f50">*</span>CPF do paciente</label>
      <input
        type="tel"
        class="form-control input-validate"
        :class="{ 'invalid-value-input': errorMessage,
                  'input-filled': (!!cx_patientDocument && cx_patientDocument.length > 0) }"
        inputmode="numeric"
        placeholder="Dígitos do CPF"
        v-mask="'###.###.###-##'"
        v-model="cx_patientDocument"
      />
      <span class="input-text" :class="{ 'invalid-value-message': errorMessage, 'cpf-message': !errorMessage }">
        {{ errorMessage || 'O CPF será utilizado para verificar se já existe um cadastro e agilizar o atendimento. Pacientes sem CPF devem agendar o serviço na clínica.' }}
      </span>
      <div class="incompleteRegistration" v-if="getPatientData && getPatientData.document && !getPatientData.email">
        <alert-message icon="error" color="#FF9100" message="O cadastro para este CPF está incompleto. Por favor, atualize as informações para concluir seu agendamento." />
      </div>
      <div
        v-else-if="
          getPatientData &&
          Object.keys(getPatientData).length !== 0 &&
          cx_patientDocument.length === 14
        "
        class="cpfIsValid"
      >
        <b-icon icon="check-circle" class="icon-check" aria-hidden="true"></b-icon>
        <span>CPF cadastrado. Continue para finalizar o agendamento.</span>
      </div>
    </div>
  </div>
</template>
<script>
import ValidatePatient from "@/components/Patient/ValidatePatient/ValidatePatient.ts";
export default ValidatePatient;
</script>

<style lang="scss" scoped>
@import "ValidatePatient.scss";
</style>
